import { SearchCritMixitCloud } from './searchCritMixitCloud';
import { SearchResponseMarket, SearchResponseVariants, SearchResponseFormula, Variants } from '../tools/api.service'

export class SearchResultMixitCloud {
    crit: SearchCritMixitCloud;
    teintesMeres: SearchResponseMarket;
    variantes: SearchResponseVariants;
    variante: Variants;
    formule: SearchResponseFormula;
}
